import { __decorate } from "tslib";
import { injectable } from "inversify";
let LocalizationOptionsProvider = class LocalizationOptionsProvider {
};
LocalizationOptionsProvider = __decorate([
    injectable()
], LocalizationOptionsProvider);
export { LocalizationOptionsProvider };
//# sourceMappingURL=LocalizationOptionsProvider.js.map